import localforage from "localforage";
import PhonePicker from "../../phone_picker/phone_picker";

frappe.ui.form.ControlPhone = class ControlPhone extends frappe.ui.form.ControlData {
	async make_input() {
		await this.setup_country_codes();
		super.make_input();
		this.setup_country_code_picker();
		this.input_events();
	}

	async setup_country_codes() {
		const key = "country_code_info";
		let data = await localforage.getItem(key);
		if (data) {
			this.country_codes = data;
		} else {
			const data = await frappe.xcall("frappe.geo.country_info.get_country_timezone_info");
			this.country_codes = data?.country_info;
			localforage.setItem(key, this.country_codes);
		}
		this.setup_nanp_area_codes();
	}
	
	setup_nanp_area_codes() {
		this.nanp_area_codes = {
				'CA': ['368', '403', '568', '587', '780', '825', '236', '250', '257', '604', '672', '778', '204', '431', '584', '428', '506', '709', '879', '867', '782', '851', '902', '226', '249', '289', '343', '365', '382', '387', '416', '437', '460', '519', '537', '548', '613', '647', '683', '705', '742', '753', '807', '905', '942', '263', '354', '367', '418', '438', '450', '468', '514', '579', '581', '819', '873', '306', '474', '639'],
				'AI': ['264'],
				'AG': ['268'],
				'BS': ['242'],
				'BB': ['246'],
				'BM': ['441'],
				'VG': ['284'],
				'KY': ['345'],
				'DM': ['767'],
				'DO': ['809', '829', '849'],
				'GD': ['473'],
				'JM': ['658', '876'],
				'MS': ['664'],
				'PR': ['787', '939'],
				'KN': ['869'],
				'LC': ['758'],
				'VC': ['784'],
				'SX': ['721'],
				'TT': ['868'],
				'TC': ['649'],
				'VI': ['340'],
				'AS': ['684'],
				'GU': ['671'],
				'MP': ['670']
		};
	}

	get_nanp_country_code(area_code) {
			for (const [country_code, area_codes] of Object.entries(this.nanp_area_codes)) {
					if (area_codes.includes(area_code)) {
							return country_code;
					}
			}
			return 'US'; // Default to US if not found
	}

	set_formatted_input(value) {
			if (value && value.includes("-") && value.split("-").length == 2) {
					let [isd, number] = value.split("-");
					if (isd === '+1' || isd === '1') {
							const area_code = number.substr(0, 3);
							const country_code = this.get_nanp_country_code(area_code);
							this.set_flag(country_code.toLowerCase());
							this.$isd.text('+1');
					} else {
							this.get_country_code_and_change_flag(isd);
					}
					this.country_code_picker.set_country(isd);
					this.country_code_picker.refresh();
					this.update_padding();
					this.$input.val(number);
			} else if (this.$isd.text().trim() && value) {
					let code_number = this.$isd.text() + "-" + value;
					this.set_value(code_number);
			}
	}
	input_events() {
		this.$input.keydown((e) => {
			const key_code = e.keyCode;
			if ([frappe.ui.keyCode.BACKSPACE].includes(key_code)) {
				if (this.$input.val().length == 0) {
					this.country_code_picker.reset();
				}
			}
		});
		this.$input.on('input', () => {
			const value = this.$input.val();
			if (this.$isd.text() === '+1' && value.length >= 3) {
					const area_code = value.substr(0, 3);
					const country_code = this.get_nanp_country_code(area_code);
					this.set_flag(country_code.toLowerCase());
			}
	  });
		// Replaces code when selected and removes previously selected.
		this.country_code_picker.on_change = (country) => {
			if (!country) {
				return this.reset_input();
			}
			const country_code = this.country_codes[country].code;
			const country_isd = this.country_codes[country].isd;
			if (this.$isd.text() === '+1' && this.value.split("-",2)[1] >= 3) {
				const area_code = this.value.split("-",2)[1];
				const country_code = this.get_nanp_country_code(area_code);
				this.set_flag(country_code.toLowerCase());
			} else {
				this.set_flag(country_code);
			}

			this.$icon = this.selected_icon.find("svg");
			this.$flag = this.selected_icon.find("img");

			if (!this.$icon.hasClass("hide")) {
				this.$icon.toggleClass("hide");
			}
			if (!this.$flag.length) {
				this.selected_icon.prepend(this.get_country_flag(country));
			}
			if (!this.$isd.length) {
				this.selected_icon.append($(`<span class= "country"> ${country_isd}</span>`));
			} else {
				this.$isd.text(country_isd);
			}
			if (this.$input.val()) {
				this.set_value(this.get_country(country) + "-" + this.$input.val());
			}
			this.update_padding();
			// hide popover and focus input
			this.$wrapper.popover("hide");
			this.$input.focus();
		};

		this.$wrapper.find(".selected-phone").on("click", (e) => {
			this.$wrapper.popover("toggle");
			e.stopPropagation();

			$("body").on("click.phone-popover", (ev) => {
				if (!$(ev.target).parents().is(".popover")) {
					this.$wrapper.popover("hide");
				}
			});
			$(window).on("hashchange.phone-popover", () => {
				this.$wrapper.popover("hide");
			});
		});
	}

	setup_country_code_picker() {
		let picker_wrapper = $("<div>");
		this.country_code_picker = new PhonePicker({
			parent: picker_wrapper,
			countries: this.country_codes,
		});

		this.$wrapper
			.popover({
				trigger: "manual",
				offset: `${-this.$wrapper.width() / 4.5}, 5`,
				boundary: "viewport",
				placement: "bottom",
				template: `
				<div class="popover phone-picker-popover">
					<div class="picker-arrow arrow"></div>
					<div class="popover-body popover-content"></div>
				</div>
			`,
				content: () => picker_wrapper,
				html: true,
			})
			.on("show.bs.popover", () => {
				setTimeout(() => {
					this.country_code_picker.refresh();
					this.country_code_picker.search_input.focus();
				}, 10);
			})
			.on("hidden.bs.popover", () => {
				$("body").off("click.phone-popover");
				$(window).off("hashchange.phone-popover");
			});

		// Default icon when nothing is selected.
		this.selected_icon = this.$wrapper.find(".selected-phone");
		let input_value = this.get_input_value();
		if (!this.selected_icon.length) {
			this.selected_icon = $(
				`<div class="selected-phone">${frappe.utils.icon("down", "sm")}</div>`
			);
			this.selected_icon.insertAfter(this.$input);
			this.selected_icon.append($(`<span class= "country"></span>`));
			this.$isd = this.selected_icon.find(".country");
			if (input_value && input_value.split("-").length == 2) {
				this.$isd.text(this.value.split("-")[0]);
			}
		}
	}

	refresh() {
		super.refresh();
		// Previously opened doc values showing up on a new doc

		if (this.frm && this.frm.doc.__islocal && !this.get_value()) {
			this.reset_input();
		}
	}

	reset_input() {
		if (!this.$input) return;
		this.$input.val("");
		this.$wrapper.find(".country").text("");
		if (this.selected_icon.find("svg").hasClass("hide")) {
			this.selected_icon.find("svg").toggleClass("hide");
			this.selected_icon.find("img").addClass("hide");
		}
		this.$input.css("padding-left", 30);
	}

	async set_formatted_input(value) {
		if (!this.country_codes) {
			await this.setup_country_codes();
		}
		if (value && value.includes("-") && value.split("-").length == 2) {
			let isd = this.value.split("-")[0];
			this.get_country_code_and_change_flag(isd);
			this.country_code_picker.set_country(isd);
			this.country_code_picker.refresh();
			if (
				this.country_code_picker.country &&
				this.country_code_picker.country !== this.$isd.text()
			) {
				this.$isd.length && this.$isd.text(isd);
			}
			this.update_padding();
			this.$input.val(value.split("-").pop());
		} else if (this.$isd.text().trim() && this.value) {
			let code_number = this.$isd.text() + "-" + value;
			this.set_value(code_number);
		}
	}

	get_value() {
		return this.value;
	}

	set_flag(country_code) {
		const flag_url = `https://flagcdn.com/${country_code.toLowerCase()}.svg`;
		this.selected_icon.find("img").attr("src", flag_url);
		this.$icon = this.selected_icon.find("img");
		if (this.$icon.hasClass("hide")) {
				this.$icon.removeClass("hide");
		}
		if (this.selected_icon.find("svg").length) {
				this.selected_icon.find("svg").addClass("hide");
		}
	}

	// country_code for India is 'in'
	get_country_code_and_change_flag(isd) {
		let country_data = this.country_codes;
		console.log(country_data)
		let flag = this.selected_icon.find("img");
		let code = '';
		let country = '';
		console.log(this.value.split("-",2)[1],isd)
		if (isd === '+1' || isd === '1') {
			// NANP number, check the area code
			const number = this.value.split("-",2)[1];
			console.log(number,number.length)
			if (number.length >= 3) {
					const area_code = number.substr(0, 3);
					code = this.get_nanp_country_code(area_code);
					for (const [countryName, countryInfo] of Object.entries(country_data)) {
						if (countryInfo.code.toLowerCase() === code.toLowerCase()) {
								country = countryName;
								break;
						}
					}
			} else {
					code = 'US'; // Default to US if we don't have enough digits yet
					country = 'United States';
			}
		} else {
				// Non-NANP number, find the country as before
				for (const c in country_data) {
						if (Object.values(country_data[c]).includes(isd)) {
								code = country_data[c].code;
								console.log(country_data,c)
								country = c;
								break;
						}
				}
		}

		if (code) {
				if (!flag.length) {
						this.selected_icon.prepend(this.get_country_flag(country));
						this.selected_icon.find("svg").addClass("hide");
				} else {
						this.set_flag(code);
				}
				console.log(`Setting flag for country code: ${code}`);
		}
	}

	get_country(country) {
		const country_codes = this.country_codes;
		return country_codes[country].isd;
	}

	get_country_flag(country) {
		if (!this.country_codes[country] || !this.country_codes[country].code) {
			console.warn(`Invalid country or missing code for: ${country}`);
			return ''; // Return an empty string or a default flag
		}
		const code = this.country_codes[country].code.toLowerCase();
		return frappe.utils.flag(code);
	}

	update_padding() {
		let len = this.$isd.text().length;
		let diff = len - 2;
		if (len > 2) {
			this.$input.css("padding-left", 60 + diff * 7);
		} else {
			this.$input.css("padding-left", 60);
		}
	}
};

